import { Outlet } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { isPreviewMode } from '../services/supabase';

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {isPreviewMode() && (
        <div className="bg-gold-500 text-ink-950 px-4 py-2 text-center text-sm font-medium shadow-sm">
          Preview Mode - Some features are simulated
        </div>
      )}

      <Navbar />
      <div className="flex-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}